import View from './view';
import {target} from '../utils/dom';

const defaults = {
	el: null
};

class SmartlightingFeatures extends View {
	constructor(options) {
		super(options, defaults);
		if (this.el === null || this.el === undefined) return;
		this.triggers = this.el.queryAll('[data-feature-trigger]');
		this.descriptions = this.el.queryAll('[data-feature]');
		this.initEvents();
		this.checkUrl();
	}

	initEvents() {
		super.initEvents();
		this.el.addEventListener('click', this.onClick.bind(this));
	}

	checkUrl() {
		if (window.location.hash) {
			const el = document.query(window.location.hash);
			if (el) {
				this.triggerFeature(el);
			}
		}
	}

	onClick(event) {
		const trigger = target(event.target, '[data-feature-trigger]');
		if (trigger) {
			event.preventDefault();
			this.triggerFeature(trigger);
		}
	}

	triggerFeature(trigger) {
		let selectedFeature = trigger.getAttribute('data-feature-trigger');

		trigger.classList.toggle('active');
		this.triggers.forEach((item) => {
			if (item !== trigger) {
				item.classList.remove('active');
			}
		});

		// descriptions
		this.descriptions.forEach((description) => {
			if (description.getAttribute('data-feature') === selectedFeature) {
				description.classList.add('active');
			} else {
				description.classList.remove('active');
			}
		});
	}
}
let features = new SmartlightingFeatures({
	el: document.query('.slx-smartlighting')
});
